// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { AssetInfoFragmentDoc } from '../../projects/assets/AssetPreview.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type OptionDrawerMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OptionDrawerMetadataQuery = { __typename?: 'Query', globalOptionTypes: Array<{ __typename?: 'GlobalOptionType', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, forDesignUpgrade: boolean, isPlanPackage: boolean, isCatalogV2?: boolean | null | undefined, version: number }>, globalOptionGroups: Array<{ __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, forDesignUpgrade: boolean, version: number, type: { __typename?: 'GlobalOptionType', isPlanPackage: boolean, isCatalogV2?: boolean | null | undefined, id: string, name: string } }> };

export type GlobalOptionDrawerQueryVariables = Types.Exact<{
  globalOptionId: Types.Scalars['ID']['input'];
}>;


export type GlobalOptionDrawerQuery = { __typename?: 'Query', globalOption: { __typename?: 'GlobalOption', id: string, name: string, code: string, defaultOrder?: number | null | undefined, standardDetailRequired?: boolean | null | undefined, requiredInPlanDrawing?: boolean | null | undefined, elevationRequired?: boolean | null | undefined, shopDrawingRequired?: boolean | null | undefined, description?: string | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, name: string }, type: { __typename?: 'GlobalOptionType', id: string, name: string }, statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined } }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, canEditType: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } };

export type SaveGlobalOptionsDrawerMutationVariables = Types.Exact<{
  input: Types.SaveGlobalOptionsInput;
}>;


export type SaveGlobalOptionsDrawerMutation = { __typename?: 'Mutation', saveGlobalOptions: { __typename?: 'SaveGlobalOptionsResult', globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, code: string, defaultOrder?: number | null | undefined, standardDetailRequired?: boolean | null | undefined, requiredInPlanDrawing?: boolean | null | undefined, elevationRequired?: boolean | null | undefined, shopDrawingRequired?: boolean | null | undefined, description?: string | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, name: string }, type: { __typename?: 'GlobalOptionType', id: string, name: string }, statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined } }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, canEditType: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined }> } };

export type SaveGlobalOptionGroupMutationVariables = Types.Exact<{
  input: Types.SaveGlobalOptionGroupInput;
}>;


export type SaveGlobalOptionGroupMutation = { __typename?: 'Mutation', saveGlobalOptionGroup: { __typename?: 'SaveGlobalOptionGroupResult', entity: { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, forDesignUpgrade: boolean, version: number, type: { __typename?: 'GlobalOptionType', isPlanPackage: boolean, isCatalogV2?: boolean | null | undefined, id: string, name: string } } } };

export type GlobalOptionGroupInDrawerFragment = { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, forDesignUpgrade: boolean, version: number, type: { __typename?: 'GlobalOptionType', isPlanPackage: boolean, isCatalogV2?: boolean | null | undefined, id: string, name: string } };

export type GlobalOptionInDrawerFragment = { __typename?: 'GlobalOption', id: string, name: string, code: string, defaultOrder?: number | null | undefined, standardDetailRequired?: boolean | null | undefined, requiredInPlanDrawing?: boolean | null | undefined, elevationRequired?: boolean | null | undefined, shopDrawingRequired?: boolean | null | undefined, description?: string | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, name: string }, type: { __typename?: 'GlobalOptionType', id: string, name: string }, statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined } }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, canEditType: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined };

export const GlobalOptionGroupInDrawerFragmentDoc = gql`
    fragment GlobalOptionGroupInDrawer on GlobalOptionGroup {
  id
  name
  forDesignInterior
  forDesignExterior
  forDesignUpgrade
  type {
    ...Named
    isPlanPackage
    isCatalogV2
  }
  version
}
    ${NamedFragmentDoc}`;
export const GlobalOptionInDrawerFragmentDoc = gql`
    fragment GlobalOptionInDrawer on GlobalOption {
  id
  name
  code
  defaultOrder
  group {
    id
    name
  }
  type {
    id
    name
  }
  standardDetailRequired
  requiredInPlanDrawing
  elevationRequired
  shopDrawingRequired
  description
  statusDetail {
    code
    name
  }
  readyPlanOptions {
    id
    name
    active
    readyPlan {
      id
      name
      development {
        id
        name
      }
    }
  }
  locations {
    id
    name
  }
  canEditType {
    allowed
    disabledReasons {
      message
    }
  }
  asset {
    ...AssetInfo
  }
}
    ${AssetInfoFragmentDoc}`;
export const OptionDrawerMetadataDocument = gql`
    query OptionDrawerMetadata {
  globalOptionTypes(filter: {version: [1, 2]}) {
    id
    name
    forDesignInterior
    forDesignExterior
    forDesignUpgrade
    isPlanPackage
    isCatalogV2
    version
  }
  globalOptionGroups(filter: {version: [1, 2], isSingleOptionGroup: false}) {
    ...GlobalOptionGroupInDrawer
  }
}
    ${GlobalOptionGroupInDrawerFragmentDoc}`;

/**
 * __useOptionDrawerMetadataQuery__
 *
 * To run a query within a React component, call `useOptionDrawerMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionDrawerMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionDrawerMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useOptionDrawerMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>(OptionDrawerMetadataDocument, options);
      }
export function useOptionDrawerMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>(OptionDrawerMetadataDocument, options);
        }
// @ts-ignore
export function useOptionDrawerMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>;
export function useOptionDrawerMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OptionDrawerMetadataQuery | undefined, OptionDrawerMetadataQueryVariables>;
export function useOptionDrawerMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>(OptionDrawerMetadataDocument, options);
        }
export type OptionDrawerMetadataQueryHookResult = ReturnType<typeof useOptionDrawerMetadataQuery>;
export type OptionDrawerMetadataLazyQueryHookResult = ReturnType<typeof useOptionDrawerMetadataLazyQuery>;
export type OptionDrawerMetadataSuspenseQueryHookResult = ReturnType<typeof useOptionDrawerMetadataSuspenseQuery>;
export type OptionDrawerMetadataQueryResult = ApolloReactCommon.QueryResult<OptionDrawerMetadataQuery, OptionDrawerMetadataQueryVariables>;
export const GlobalOptionDrawerDocument = gql`
    query GlobalOptionDrawer($globalOptionId: ID!) {
  globalOption(id: $globalOptionId) {
    ...GlobalOptionInDrawer
  }
}
    ${GlobalOptionInDrawerFragmentDoc}`;

/**
 * __useGlobalOptionDrawerQuery__
 *
 * To run a query within a React component, call `useGlobalOptionDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOptionDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOptionDrawerQuery({
 *   variables: {
 *      globalOptionId: // value for 'globalOptionId'
 *   },
 * });
 */
export function useGlobalOptionDrawerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables> & ({ variables: GlobalOptionDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables>(GlobalOptionDrawerDocument, options);
      }
export function useGlobalOptionDrawerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables>(GlobalOptionDrawerDocument, options);
        }
// @ts-ignore
export function useGlobalOptionDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables>;
export function useGlobalOptionDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionDrawerQuery | undefined, GlobalOptionDrawerQueryVariables>;
export function useGlobalOptionDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables>(GlobalOptionDrawerDocument, options);
        }
export type GlobalOptionDrawerQueryHookResult = ReturnType<typeof useGlobalOptionDrawerQuery>;
export type GlobalOptionDrawerLazyQueryHookResult = ReturnType<typeof useGlobalOptionDrawerLazyQuery>;
export type GlobalOptionDrawerSuspenseQueryHookResult = ReturnType<typeof useGlobalOptionDrawerSuspenseQuery>;
export type GlobalOptionDrawerQueryResult = ApolloReactCommon.QueryResult<GlobalOptionDrawerQuery, GlobalOptionDrawerQueryVariables>;
export const SaveGlobalOptionsDrawerDocument = gql`
    mutation SaveGlobalOptionsDrawer($input: SaveGlobalOptionsInput!) {
  saveGlobalOptions(input: $input) {
    globalOptions {
      ...GlobalOptionInDrawer
    }
  }
}
    ${GlobalOptionInDrawerFragmentDoc}`;

/**
 * __useSaveGlobalOptionsDrawerMutation__
 *
 * To run a mutation, you first call `useSaveGlobalOptionsDrawerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalOptionsDrawerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalOptionsDrawerMutation, { data, loading, error }] = useSaveGlobalOptionsDrawerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGlobalOptionsDrawerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalOptionsDrawerMutation, SaveGlobalOptionsDrawerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalOptionsDrawerMutation, SaveGlobalOptionsDrawerMutationVariables>(SaveGlobalOptionsDrawerDocument, options);
      }
export type SaveGlobalOptionsDrawerMutationHookResult = ReturnType<typeof useSaveGlobalOptionsDrawerMutation>;
export type SaveGlobalOptionsDrawerMutationResult = ApolloReactCommon.MutationResult<SaveGlobalOptionsDrawerMutation>;
export const SaveGlobalOptionGroupDocument = gql`
    mutation SaveGlobalOptionGroup($input: SaveGlobalOptionGroupInput!) {
  saveGlobalOptionGroup(input: $input) {
    entity {
      ...GlobalOptionGroupInDrawer
    }
  }
}
    ${GlobalOptionGroupInDrawerFragmentDoc}`;

/**
 * __useSaveGlobalOptionGroupMutation__
 *
 * To run a mutation, you first call `useSaveGlobalOptionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalOptionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalOptionGroupMutation, { data, loading, error }] = useSaveGlobalOptionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGlobalOptionGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalOptionGroupMutation, SaveGlobalOptionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalOptionGroupMutation, SaveGlobalOptionGroupMutationVariables>(SaveGlobalOptionGroupDocument, options);
      }
export type SaveGlobalOptionGroupMutationHookResult = ReturnType<typeof useSaveGlobalOptionGroupMutation>;
export type SaveGlobalOptionGroupMutationResult = ApolloReactCommon.MutationResult<SaveGlobalOptionGroupMutation>;